import { getItemMaker } from "./tools";

const i = getItemMaker("obols");
export const obols = [
  i("Bronze STR Obol", "ObolBronze0"),
  i("Bronze AGI Obol", "ObolBronze1"),
  i("Bronze WIS Obol", "ObolBronze2"),
  i("Bronze LUK Obol", "ObolBronze3"),
  i("Bronze Obol of Cards"),
  i("Bronze Obol of Chippin Chops", "ObolBronzeChoppin"),
  i("Bronze Obol of Construction", "ObolBronzeCons"),
  i("Bronze Obol of Defence", "ObolBronzeDef"),
  i("Bronze Obol of Experience", "ObolBronzeEXP"),
  i("Bronze Obol of Few Flies"),
  i("Bronze Obol of Finite Fish", "ObolBronzeFishing"),
  i("Bronze Obol of Multikill", "ObolBronzeKill"),
  i("Bronze Obol of Pop", "ObolBronzePop"),
  i("Bronze Obol of Puny Damage", "ObolBronzeDamage"),
  i("Bronze Obol of Small Swings", "ObolBronzeMining"),
  i("Bronze Obol of Trapping", "ObolBronzeTrapping"),
  i("Bronze Obol of Worship", "ObolBronzeWorship"),

  i("Silver STR Obol", "ObolSilver0"),
  i("Silver AGI Obol", "ObolSilver1"),
  i("Silver WIS Obol", "ObolSilver2"),
  i("Silver LUK Obol", "ObolSilver3"),
  i("Silver Obol of Big Bark", "ObolSilverChoppin"),
  i("Silver Obol of Big Bugs", "ObolSilverCatching"),
  i("Silver Obol of Cards", "ObolSilverCard"),
  i("Silver Obol of Construction", "ObolSilverCons"),
  i("Silver Obol of Defence", "ObolSilverDef"),
  i("Silver Obol of Double Sixes", "ObolSilverLuck"),
  i("Silver Obol of Experience", "ObolSilverEXP"),
  i("Silver Obol of Little Damage", "ObolSilverDamage"),
  i("Silver Obol of Megakill", "ObolSilverKill"),
  i("Silver Obol of Moderate Mining", "ObolSilverMining"),
  i("Silver Obol of Pocket Change", "ObolSilverMoney"),
  i("Silver Obol of Pop Pop", "ObolSilverPop"),
  i("Silver Obol of Puny Pikes", "ObolSilverFishing"),
  i("Silver Obol of Trapping", "ObolSilverTrapping"),
  i("Silver Obol of Worship", "ObolSilverWorship"),

  i("Gold STR Obol", "ObolGold0"),
  i("Gold AGI Obol", "ObolGold1"),
  i("Gold WIS Obol", "ObolGold2"),
  i("Gold LUK Obol", "ObolGold3"),
  i("Golden Obol of Big Boy Damage", "ObolGoldDamage"),
  i("Golden Obol of Cards", "ObolGoldCard"),
  i("Golden Obol of Construction", "ObolGoldCons"),
  i("Golden Obol of Crazy Carp"),
  i("Golden Obol of Defence", "ObolGoldDef"),
  i("Golden Obol of Diligent Digging"),
  i("Golden Obol of Experience", "ObolGoldEXP"),
  i("Golden Obol of Huge Hackin"),
  i("Golden Obol of Insane Insects"),
  i("Golden Obol of Plentiful Riches", "ObolGoldMoney"),
  i("Golden Obol of Poppity Pop", "ObolGoldPop"),
  i("Golden Obol of Trapping"),
  i("Golden Obol of Triple Sixes", "ObolGoldLuck"),
  i("Golden Obol of Ultrakill", "ObolGoldKill"),
  i("Golden Obol of Worship"),

  i("Platinum STR Obol", "ObolPlatinum0"),
  i("Platinum AGI Obol", "ObolPlatinum1"),
  i("Platinum WIS Obol", "ObolPlatinum2"),
  i("Platinum LUK Obol", "ObolPlatinum3"),
  i("Platinum Obol of Ample Anthropods"),
  i("Platinum Obol of Blinding Speed"),
  i("Platinum Obol of Cards", "ObolPlatinumCard"),
  i("Platinum Obol of Construction"),
  i("Platinum Obol of Defense with an S"),
  i("Platinum Obol of Dwarven Delving"),
  i("Platinum Obol of Experience"),
  i("Platinum Obol of Killimanjaro"),
  i("Platinum Obol of Lethal Damage"),
  i("Platinum Obol of Lumby Loggo"),
  i("Platinum Obol of Poppity Poppy"),
  i("Platinum Obol of Trapping"),
  i("Platinum Obol of Tremendous Trout"),
  i("Platinum Obol of Worship"),
  i("Platinum Obol of Yahtzee Sixes", "ObolPlatinumLuck"),

  i("Dementia STR Obol", "ObolDementia0"),
  i("Dementia AGI Obol", "ObolDementia1"),
  i("Dementia WIS Obol", "ObolDementia2"),
  i("Dementia LUK Obol", "ObolDementia3"),
  i("Dementia Obol of Cards"),
  i("Dementia Obol of Colossal Crawlies"),
  i("Dementia Obol of Construction"),
  i("Dementia Obol of Defence"),
  i("Dementia Obol of Experience"),
  i("Dementia Obol of Infinisixes"),
  i("Dementia Obol of Infinite Damage"),
  i("Dementia Obol of Killionaire"),
  i("Dementia Obol of Magisterial Metals"),
  i("Dementia Obol of Monument Marlins"),
  i("Dementia Obol of Pop Pop Pop Pop"),
  i("Dementia Obol of Trapping"),
  i("Dementia Obol of Worship"),
  i("Dementia Obol of WOWOWOWWO"),

  i("Hyper DMG Obol", "ObolHyperB2"),
  i("Hyper DMG Obol B"),
  i("Hyper Pyre Obol"),
  i("Hyper Pyre Obol B", "ObolHyperB1"),
  i("Hyper Six Obol"),
  i("Hyper Six Obol B"),
  i("Hyper Skull Obol"),
  i("Hyper Skull Obol B"),

  i("Frozen Obol of Chizoar's Rage", "ObolChizoarA"),
  i("Granite Obol of Amarok's Stare", "ObolAmarokA"),
  i("Grumpy Obol of the Grandfrogger", "ObolFrog"),
  i("Jagged Obol of Massive Trolling"),
  i("Magma Obol of Big Time Domeo"),
  i("Molten Obol of Dead Divine"),
  i("Skeletal Obol of Efaunt's Gaze", "ObolEfauntA"),
  i("Slushy Obol of Much Dilapidation", "ObolSlush"),
  i("Vigilant Obol of Ice Guard", "ObolKnight"),
];
